var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChainalysisLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Logo",
    xmlns: "http://www.w3.org/2000/svg",
    width: 243,
    height: 57,
    viewBox: "0 0 617 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Chainalysis_logo_RGB_Orange") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ff5300",
    d: "M143.72,49.28c0,12.17,9.09,20.29,20.11,20.29a32.22,32.22,0,0,0,16.94-4.77V76.62c-2.29,1.42-9.17,4-16.85,4C146,80.59,131.81,67,131.81,49.28S146,18,163.92,18c7.68,0,14.56,2.56,16.85,4V33.75A32.32,32.32,0,0,0,163.83,29C152.81,29,143.72,37.11,143.72,49.28Z",
    transform: "translate(0)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff5300",
    d: "M233.5,50V79.71h-11V53.51c0-5.2-2.3-9.08-8.21-9.08-5.73,0-9.08,3.61-9.08,10.14V79.71h-11V15.32h11V42.93c.79-2,3.88-8.21,13.14-8.21C227.86,34.72,233.5,40.37,233.5,50Z",
    transform: "translate(0)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff5300",
    d: "M293.31,70.45v9.26h-14.2A1.67,1.67,0,0,1,277.34,78V70.1c-1.5,5.2-5.55,10.49-14,10.49-11.47,0-19.76-8.55-19.76-22.93,0-14.56,9.08-22.94,20.37-22.94,10.41,0,12.53,8.56,12.53,8.56V35.61h11V70.45Zm-16.5-12.7c0-8.29-4-13.5-10.58-13.5-6.35,0-11.2,4.68-11.2,13.41s4,13.41,10.67,13.41C272.49,71.07,276.81,66.66,276.81,57.75Z",
    transform: "translate(0)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff5300",
    d: "M318.56,37.37V79.71h-11V44.87h-8V35.61h17.28A1.67,1.67,0,0,1,318.56,37.37Zm-.35-10.94H306.3V15.32h11.91Z",
    transform: "translate(0)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff5300",
    d: "M331.41,35.61h10.85v7.85c.36-1.15,3-8.74,13.32-8.74,9.53,0,15.18,5.65,15.18,15.26V79.71h-11V53.51c0-5.2-2.29-9.08-8.2-9.08-5.74,0-9.09,3.61-9.09,10.14V79.71h-11Z",
    transform: "translate(0)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff5300",
    d: "M430.56,70.45v9.26h-14.2A1.67,1.67,0,0,1,414.59,78V70.1c-1.5,5.2-5.55,10.49-14,10.49-11.47,0-19.76-8.55-19.76-22.93,0-14.56,9.08-22.94,20.38-22.94,10.41,0,12.52,8.56,12.52,8.56V35.61h11V70.45Zm-16.5-12.7c0-8.29-4-13.5-10.58-13.5-6.35,0-11.2,4.68-11.2,13.41S396.33,71.07,403,71.07C409.74,71.07,414.06,66.66,414.06,57.75Z",
    transform: "translate(0)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff5300",
    d: "M453.06,18V79.71H442V24.58h-6.88V15.32h15.26A2.65,2.65,0,0,1,453.06,18Z",
    transform: "translate(0)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff5300",
    d: "M472.87,100h-11V90.74H470c2.91,0,4.24-.88,5.29-3.53l3.27-8.29L461.58,35.61h12.26l10.32,31.13,10.68-31.13H507.1L485.4,91.44C483.11,97.35,479.31,100,472.87,100Z",
    transform: "translate(0)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff5300",
    d: "M513.21,76.89V66.22c1.5,1,7.58,5,14.38,5,5.2,0,7.49-1.5,7.49-4.41,0-8.73-22.49-2.29-22.49-18.87,0-7.5,6.35-13.24,18-13.24,6.43,0,11,1.68,12.79,2.74V48c-2.21-1.42-6.62-4.24-12.62-4.24-5.2,0-7.14,1.59-7.14,4.06,0,7.14,22.4,2.2,22.4,18.44,0,8.82-7.32,14.37-18,14.37C521,80.59,515.24,78.21,513.21,76.89Z",
    transform: "translate(0)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff5300",
    d: "M572.4,37.37V79.71h-11V44.87h-8V35.61h17.29A1.66,1.66,0,0,1,572.4,37.37Zm-.35-10.94H560.14V15.32h11.91Z",
    transform: "translate(0)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff5300",
    d: "M584.19,76.89V66.22c1.49,1,7.58,5,14.37,5,5.21,0,7.5-1.5,7.5-4.41,0-8.73-22.49-2.29-22.49-18.87,0-7.5,6.35-13.24,18-13.24,6.44,0,11,1.68,12.79,2.74V48a22.85,22.85,0,0,0-12.61-4.24c-5.21,0-7.15,1.59-7.15,4.06,0,7.14,22.41,2.2,22.41,18.44,0,8.82-7.32,14.37-18,14.37C592,80.59,586.21,78.21,584.19,76.89Z",
    transform: "translate(0)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff5300",
    d: "M50,0c1.12,0,2.39.14,2.39.14a28.31,28.31,0,0,0-6.48,15.92A33.76,33.76,0,0,0,18.05,44.65c-6.47.7-13.79,3.66-18,7.89C-.95,23.52,21.29,0,50,0ZM57.2,87.18a27,27,0,0,1-4,.29,49.17,49.17,0,0,1-6.9-.57,51.83,51.83,0,0,1-7,12A50,50,0,0,1,1.72,62.82c4.51-5.35,14.93-8.45,21.4-8.45,13.8,0,21.12,7.32,23.66,18.73-8.31-2.25-13.24-6.9-16.48-13.8a16.68,16.68,0,0,0-5.91-1,16.83,16.83,0,0,0-5.35.85C22.7,73.1,36.22,83.52,52.69,83.52c15.21,0,21.68-7.74,21.68-7.74V63.94s-7.46,7.75-16.75,9.3A33.74,33.74,0,0,0,28.9,44.65C31.29,32.82,40.3,26.2,52.55,26.2s22.11,8.87,22.11,8.87V23.38s-6.34-5.92-17.6-7.18C57.34,11,60.72,4.51,64.38,2.11,79.72,6.9,94.51,19.86,98.73,38.73c0,0-6.76,6.76-19.43,6.76-10.42,0-17-5.21-20.7-14.36a17.28,17.28,0,0,0-6.05-1,15.4,15.4,0,0,0-5.63,1c4.08,14.65,17,24.5,31.4,24.5,14.08,0,21.68-6.47,21.68-6.47C100,78.45,77.61,99.44,51,100,54.1,97,56.49,90.42,57.2,87.18Z",
    transform: "translate(0)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChainalysisLogo);
export default __webpack_public_path__ + "static/media/chainalysis-logo.35f5850d3723006e93fc3abaf6fc24c4.svg";
export { ForwardRef as ReactComponent };